import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicyContent"] */ "/app/apps/platform-web/app/legal/privacy/PrivacyPolicyContent.tsx");
